import type { CountryConfig, CountrySetting } from '@ngb-frontend/shared/types'

export const mockCountrySettings: CountrySetting[] = [
  {
    attributes: {
      type: 'Booking_FE_Setting__c',
      url: '/services/data/v63.0/sobjects/Booking_FE_Setting__c/a2hKL0000004CipYAE',
    },
    Id: 'a2hKL0000004CipYAE',
    EnableDetailedReplacementVehicle__c: false,
    EnabledAdditionalServices__c: 'PickupAndReturn;ReplacementVehicle;MOT',
    EnabledMalfunctions__c: 'HeadLightNotWorking',
    AgentMinimumDaysBooking__c: 0,
    DriverMinimumDaysBooking__c: 0,
  },
]

export const mockCountryConfig: CountryConfig = {
  countryCode: 'LPUK',
  detailedRPV: false,
  additionalServices: {
    PickupAndReturn: true,
    ReplacementVehicle: true,
    ComplementaryCleaning: false,
  },
  malfunctions: { lighting: ['HeadLightNotWorking'], otherIssues: ['Other'] },
  minBookingDaysDriver: 8,
  minBookingDaysAgent: 7,
  autopickPNRSupplier: false,
  isAyvens: false,
  is: {
    Sweden: false,
    Austria: false,
    Switzerland: false,
    Romania: true,
    Default: false,
    Czechia: false,
    Finland: false,
    Bulgaria: false,
    Serbia: false,
    Luxembourg: false,
    Global: false,
    UK: true,
  },
}

export const mockCountryConfigFinland: CountryConfig = {
  countryCode: '24601', // Finland
  detailedRPV: false,
  additionalServices: {
    PickupAndReturn: true,
    ReplacementVehicle: true,
    ComplementaryCleaning: false,
    MOT: false,
  },
  malfunctions: { lighting: ['HeadLightNotWorking'], otherIssues: ['Other'] },
  minBookingDaysDriver: 8,
  minBookingDaysAgent: 7,
  autopickPNRSupplier: false,
  isAyvens: true,
  is: {
    Sweden: false,
    Default: true,
    Austria: false,
    Switzerland: false,
    Romania: false,
    Global: false,
    UK: false,
    Czechia: false,
    Finland: true,
    Bulgaria: false,
    Serbia: false,
    Luxembourg: false,
  },
}

export const mockCountryConfigSweden: CountryConfig = {
  countryCode: '75201', // Sweden
  detailedRPV: false,
  additionalServices: {
    PickupAndReturn: true,
    ReplacementVehicle: true,
    ComplementaryCleaning: false,
    MOT: true,
  },
  malfunctions: { lighting: ['HeadLightNotWorking'], otherIssues: ['Other'] },
  minBookingDaysDriver: 8,
  minBookingDaysAgent: 7,
  autopickPNRSupplier: false,
  isAyvens: true,
  is: {
    Sweden: true,
    Default: true,
    Austria: false,
    Switzerland: false,
    Romania: true,
    Global: false,
    UK: false,
    Czechia: false,
    Finland: false,
    Bulgaria: false,
    Serbia: false,
    Luxembourg: false,
  },
}
